/**
 * Druck-System (Welle 4): druckfertiges HTML von der API holen und in einem neuen Tab oeffnen
 * (Blob-URL statt document.write - funktioniert mit dem Auth-Header von apiFetch, den ein
 * simples `<a href>` nicht mitschicken koennte).
 */
import { apiFetch, toApiError } from "./api";

export async function openPrintableDocument(path: string): Promise<void> {
  const res = await apiFetch(path);
  if (!res.ok) throw await toApiError(res);
  const html = await res.text();
  const blob = new Blob([html], { type: "text/html" });
  const url = URL.createObjectURL(blob);
  const win = window.open(url, "_blank");
  if (win) win.addEventListener("load", () => URL.revokeObjectURL(url), { once: true });
}
